import React from 'react';

import DateFilter from './DateFilter';
import UsersFilter from './UsersFilter';
import WorkspacesFilter from './WorkspacesFilter';
import CompletedFilter from './CompletedFilter/CompletedFilter';

import './index.scss';
import { WpIcon } from 'Wpds/components/icon';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

type Props = {
  isOpen: boolean;
  onFilterOpenToggle: (event: React.MouseEvent<HTMLInputElement>) => void;
};

export default function SearchSideBar({ isOpen, onFilterOpenToggle }: Props) {
  const { tr } = useTranslation();

  return (
    <div className={`d-flex bg-light flex-column search-module-sidebar ${isOpen && 'search-module-sidebar--show'}`}>
      <div className="d-flex align-items-end justify-content-between w-100 px-3" style={{ height: '42px' }}>
        <p className="text-uppercase font-weight-bold mb-1" style={{ fontSize: '11px', lineHeight: '147%' }}>
          {tr('perform.search.sidebar.filters_title')}
        </p>
        <p className="mb-1 cursor-pointer" onClick={onFilterOpenToggle}>
          <WpIcon name="times" />
        </p>
      </div>
      <div className="px-3 search-module-sidebar-list h-100">
        <UsersFilter title={tr('perform.search.sidebar.assigned_by')} name="assignedBy" />
        <UsersFilter title={tr('perform.search.sidebar.assigned_to')} name="assignedTo" />
        <CompletedFilter />
        <WorkspacesFilter />
        <DateFilter />
      </div>
    </div>
  );
}
